import { api } from './api';
import { Product, ProductSection } from '../components/SalesManager/types';

export const salesApi = {
    // Sections
    getSections: async (): Promise<ProductSection[]> => {
        const response = await api.get('/api/sales/sections');
        return response.data;
    },

    createSection: async (section: Partial<ProductSection>): Promise<ProductSection> => {
        const response = await api.post('/api/sales/sections', section);
        return response.data;
    },

    updateSection: async (id: number, section: Partial<ProductSection>): Promise<ProductSection> => {
        const response = await api.put(`/api/sales/sections/${id}`, section);
        return response.data;
    },

    deleteSection: async (id: number): Promise<void> => {
        await api.delete(`/api/sales/sections/${id}`);
    },

    // Products
    getProducts: async (): Promise<Product[]> => {
        const response = await api.get('/api/sales/products');
        return response.data;
    },

    getProductsAdmin: async (): Promise<Product[]> => {
        const response = await api.get('/api/sales/products/admin');
        return response.data;
    },

    createProduct: async (product: Partial<Product>): Promise<Product> => {
        const response = await api.post('/api/sales/products', product);
        return response.data;
    },

    updateProduct: async (id: number, product: Partial<Product>): Promise<Product> => {
        const response = await api.put(`/api/sales/products/${id}`, product);
        return response.data;
    },

    deleteProduct: async (id: number): Promise<void> => {
        await api.delete(`/api/sales/products/${id}`);
    },

    // Commission Breakpoints
    getCommissionBreakpoints: async (): Promise<any[]> => {
        const response = await api.get('/api/sales/commission-breakpoints');
        return response.data;
    },

    getCommissionBreakpointsAdmin: async (): Promise<any[]> => {
        const response = await api.get('/api/sales/commission-breakpoints/admin');
        return response.data;
    },

    createCommissionBreakpoint: async (breakpoint: any): Promise<any> => {
        const response = await api.post('/api/sales/commission-breakpoints', breakpoint);
        return response.data;
    },

    updateCommissionBreakpoint: async (id: number, breakpoint: any): Promise<any> => {
        const response = await api.put(`/api/sales/commission-breakpoints/${id}`, breakpoint);
        return response.data;
    },

    deleteCommissionBreakpoint: async (id: number): Promise<void> => {
        await api.delete(`/api/sales/commission-breakpoints/${id}`);
    },

    getCurrentMonthInstalados: async (): Promise<{ count: number; month: number; year: number }> => {
        const response = await api.get('/api/sales/commission-breakpoints/current-month-instalados');
        return response.data;
    },

    getAdjustedCommissions: async (businessArea: string = 'telecomunicacao'): Promise<{
        current_instalados: number;
        active_breakpoint: any;
        next_breakpoint: any;
        progress_to_next: number;
        products: Array<{
            product_id: number;
            product_name: string;
            base_commission: number;
            adjusted_commission: number;
            breakpoint_applied: any;
        }>;
        business_area?: string;
    }> => {
        const response = await api.get('/api/sales/commission-breakpoints/adjusted-commissions', {
            params: { business_area: businessArea }
        });
        return response.data;
    },

    getCurrentMonthInstaladosSeguranca: async (): Promise<{ count: number; month: number; year: number }> => {
        const response = await api.get('/api/sales/commission-breakpoints/current-month-instalados-seguranca');
        return response.data;
    },

    getCurrentMonthSegurancaProductsSold: async (): Promise<{ count: number; month: number; year: number }> => {
        const response = await api.get('/api/sales/seguranca-products-sold/current-month');
        return response.data;
    }
};
